/**
 * What says this is not the user's own screen: an operator on their session, or a replay.
 *  - RoleFrame   the frame around the screen, as Settings choose (Appearance.roleFrame). The faded one
 *                lies under the regions, on the scene, so it never veils a bar or a card; the solid
 *                border lies over them, at the edge.
 *  - RoleBanner  who it is (RoleLabel), over the screen only when the layout has no top bar to hold it.
 */
import { modulesOf } from '../../layout/model';
import { useApp } from '../../react/app';
import { useAppearance, useResolvedLayout } from '../../react/hooks';
import { RoleLabel } from '../RoleLabel';
import css from './Overlays.module.css';

/** The module that shows the RoleLabel (both its looks). */
const TOP_BAR = 'progress';

export function RoleFrame({ layer }: { layer: 'under' | 'over' }) {
  const { kiosk } = useApp();
  const { roleFrame } = useAppearance();
  if (kiosk.role === 'kiosk' || roleFrame === 'off') return null;
  if ((roleFrame === 'fade') !== (layer === 'under')) return null;
  return <div className={`${css.roleFrame} ${css[kiosk.role]}`} data-frame={roleFrame} aria-hidden />;
}

export function RoleBanner() {
  const { kiosk } = useApp();
  const layout = useResolvedLayout();
  if (kiosk.role === 'kiosk' || modulesOf(layout.preset.root).includes(TOP_BAR)) return null;
  return <span className={`${css.roleTag} ${css[kiosk.role]}`}><RoleLabel /></span>;
}
